import React, { useState } from 'react'
import { ModalComponent, VideoOverlay, Image } from 'newComponents'
import './styles.scss'

const VideoComponent = ({ data }) => {
  const { title, imageUrl, videoUrl } = data

  const [modalOpen, setModalOpen] = useState(false)
  const toggleVideoModal = (e) => {
    e.preventDefault()
    setModalOpen(!modalOpen)
  }

  return (
    <div className="video-row">
      <div className="video-column">
        <Image className="two-columns-video" image={imageUrl} />
        <VideoOverlay toggleVideoModal={toggleVideoModal} />
      </div>
      <div className="text-column">{title}</div>
      <ModalComponent modalOpen={modalOpen} toggleModal={toggleVideoModal}>
        <div className="modal-content-video">
          <div className="section">
            <iframe
              title="LaunchDarkly testimonial by HoneyComb"
              src={videoUrl}
              width="100%"
              height="100%"
              frameBorder="0"
              allow="autoplay; fullscreen"
              allowFullScreen
            />
          </div>
        </div>
      </ModalComponent>
    </div>
  )
}

export default VideoComponent
